import { routes } from '@/app/routing/router'
import { PrivateErrorView } from './view'

const currentRoute = routes.privateError

const PrivateErrorPageRoute = {
  view: PrivateErrorView,
  route: currentRoute,
}

export { currentRoute, PrivateErrorPageRoute }
